var _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceUploadDocument = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 204,
  height: 194,
  viewBox: "0 0 204 194",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.286.5h159.428c5.405 0 9.786 4.381 9.786 9.786v159.428a9.786 9.786 0 0 1-9.786 9.786H10.286C4.88 179.5.5 175.119.5 169.714V10.286C.5 4.88 4.881.5 10.286.5z",
  fill: "#D7E8FD",
  stroke: "#D7E8FD"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.272 138.066H50.86c-.804 0-1.484-.673-1.484-1.541v-7.545l2.33-2.249 29.123-28.038 13.888 9.621a3.415 3.415 0 0 0 4.426-.465l19.516-20.596 13.098 10.503.007 38.769c0 .868-.688 1.541-1.492 1.541zM50.86 34.018h53.148l.254.257v24.004c0 .916.364 1.812 1.003 2.457a3.456 3.456 0 0 0 2.433 1.014h23.578l.481.493v26.656l-11.284-9.045a3.412 3.412 0 0 0-4.618.319l-19.66 20.749-13.772-9.545a3.4 3.4 0 0 0-4.315.354l-28.732 27.662V35.559c0-.868.68-1.541 1.484-1.541zm60.274 7.247 13.318 13.543h-13.318V41.265zm26.567 17.063-29.776-30.294A3.456 3.456 0 0 0 105.458 27H50.86c-4.68.007-8.425 3.853-8.431 8.56v100.965c.006 4.707 3.752 8.552 8.431 8.559h79.412c4.68-.007 8.425-3.852 8.439-8.559V60.799c0-.923-.364-1.819-1.01-2.471z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.824 61.746c3.793.007 6.865 3.11 6.872 6.942-.007 3.832-3.079 6.935-6.872 6.942-3.793-.007-6.865-3.11-6.872-6.942.007-3.832 3.079-6.935 6.872-6.942zm0 20.825c7.586 0 13.744-6.212 13.744-13.883 0-7.67-6.158-13.883-13.744-13.883-7.594 0-13.744 6.213-13.744 13.883 0 7.67 6.15 13.883 13.744 13.883z",
  fill: "#fff"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 164,
  r: 25.2,
  fill: "#6467EF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M174 137c-14.886 0-27 12.114-27 27s12.114 27 27 27 27-12.114 27-27-12.114-27-27-27zm0 51.6c-13.566 0-24.6-11.034-24.6-24.6s11.034-24.6 24.6-24.6 24.6 11.034 24.6 24.6-11.034 24.6-24.6 24.6z",
  fill: "#6467EF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M187.2 164c0 .66-.54 1.2-1.2 1.2h-10.8V176c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2v-10.8H162c-.66 0-1.2-.54-1.2-1.2 0-.66.54-1.2 1.2-1.2h10.8V152c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v10.8H186c.66 0 1.2.54 1.2 1.2z",
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceUploadDocument);
export default ForwardRef;